import { deviceId } from '../api/client.js'

/**
 * Identité de cet appareil.
 *
 * `deviceId()` vit dans le client HTTP depuis le Sprint 0 — il est posé en
 * en-tête sur chaque requête — et n'est que réexporté ici, pour que le code de
 * synchronisation n'ait pas à importer la couche réseau juste pour ça.
 */
export { deviceId }

/** Libellé lisible pour l'écran des appareils (W-33). */
export function devicePlatform(): string {
  const ua = navigator.userAgent
  if (/Android/i.test(ua)) return 'Android'
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS'
  if (/Windows/i.test(ua)) return 'Windows'
  if (/Macintosh/i.test(ua)) return 'macOS'
  if (/Linux/i.test(ua)) return 'Linux'
  return 'Navigateur'
}
